
import React,{useState} from "react";
import Link from "next/link";
import InitializePage from '../../lib/server/page'
import Header from "../../components/Layouts/Header";
import HomeFooter from '../../components/Layouts/HomeFooter.jsx';
import { useRouter } from 'next/router'
import HeaderTag from '../../components/meta.jsx';
import SubscribeNewsLetter from '../../components/common/subscribenewsletter.jsx';
import { notifyMe } from "../../helper";
import { authlogin } from '../../lib/api/auth';
import { setCookies } from 'cookies-next';

const Libreros = ({menu, webTexts}) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const router = useRouter();

    const submitLogin = async () => {        
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (email == '') {
        notifyMe({ key: 'signIn', method: 'error', message: 'Error', description: 'El email es obligatorio' });
        return false;
        }
        if (pattern.test(email) == false) {
        notifyMe({ key: 'signIn', method: 'error', message: 'Error', description: 'El email no parece válido' });
        return false;
        }

        if (password == '') {
        notifyMe({ key: 'signIn', method: 'error', message: 'Error', description: 'La contraseña es necesaria' });
        return false;
        }

        if (email != '' && password != '') {

        try {            
            
            const obj = {"email":  Buffer.from(email).toString('base64'), "password": Buffer.from(password).toString('base64'), "xShopId":6};
            const response = await authlogin(obj);

            if (response.success === true) {
                
                setCookies('LibAuthToken', Buffer.from(email).toString('base64'),{ maxAge: 60 * 60 * 24 * 30, domain: 'localhost'});

                router.push('https://librerias.eccediciones.com/?libToken='+ Buffer.from(email).toString('base64'));
                
                return;
            } else {
              if(response.responseCode === 141)
              {
                //  setUserNotValidated('1');
                    //router.push('/auth/validation_resend');
            
                    router.push({
                    pathname: '/auth/validation_resend',
                    query: { email: email}
                }, '/auth/validation_resend')
              }
              else {
                
                notifyMe({ key: 'signIn', method: 'error', message: 'Error en el login', description: 'Verifica que el email y contraseña sean correctos' });
                return;
              }

            }

        } catch (err) {            
            notifyMe({ key: 'signIn', method: 'error', message: 'Error en login', description: 'Ha ocurrido un error, vuelve a intentarlo más tarde.' });
            return;
        }

        }
    };
  

  return (
    <>
        <Header page={'common'} menuSections={menu}/>
        <HeaderTag title="Eccediciones" description="eccomics" />
            <div className="container-fluid">
                <div className="container innerpage main-container libreros-container">
                    <div className="registrar">
                        <h2 className="A-la-venta-esta-sema">Libreros</h2>
                        <div className="line4"></div>
                        <div className="form cont_form_2">
                            <h5>Bienvenido.<br />

                              Estás accediendo al área de librerias de ECC Ediciones.
                              Introduce tus datos para acceder a tu cuenta

                            </h5>
                            <h4>E-mail</h4>
                            <input type="text" onChange={(event) => setEmail(event.target.value)}/>
                            <h4>Contraseña</h4>
                            <input type="password" onChange={(event) => setPassword(event.target.value)}/>
                            <button className="btn2_cont libreros" onClick={submitLogin}>Entrar</button>
                            <div className="link-form">
                            <Link href="/auth/forgotpassword?lib=1" passHref={true}><a><b><u>¿Has olvidado tu contraseña?</u></b></a></Link><br/>
                            <Link href="/alta" passHref={true}><a>¿Todavía no eres cliente?<b><u> Haz clic aquí</u></b></a></Link>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
                </div>
                <div className="container line-container">
                  <div className="line6"></div>
                </div>
                <SubscribeNewsLetter webTexts={webTexts}/>
        <HomeFooter />
    </>
  );
};

async function loadData(context){                   
    return {};
}

export async function getStaticProps(context) {    
    return InitializePage(context,loadData, true)
}

export default Libreros;
